// src/components/RequireAuth.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";

export default function RequireAuth({ children }) {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setChecking(false);

      if (!u) {
        navigate("/", { replace: true });
      }
    });

    return () => unsub();
  }, [navigate]);

  // still checking auth status
  if (checking) {
    return (
      <div style={{ 
        height: "100vh", 
        background: "#050505", 
        display: "flex", 
        flexDirection: "column",
        justifyContent: "center", 
        alignItems: "center" 
      }}>
        <div style={{ 
          width: 40, 
          height: 40, 
          border: "3px solid rgba(255,107,0,0.1)", 
          borderTop: "3px solid #FF6B00", 
          borderRadius: "50%", 
          animation: "spin 1s linear infinite" 
        }}></div>
        <div style={{ marginTop: 20, color: "rgba(255,255,255,0.4)", fontSize: 11, fontWeight: 800, letterSpacing: 2, textTransform: "uppercase" }}>
          Validating Uplink
        </div>
        <style>{`
          @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
        `}</style>
      </div>
    );
  }

  // not logged in → redirected already
  if (!user) return null;

  // logged in → show page
  return children;
}
